import StatisticSimpleView from './StatisticSimpleView'

export default StatisticSimpleView
